import React from 'react'
import PropTypes from 'prop-types';

import Button from 'PMT/components/Button'
import I18n from 'PMT/i18n/I18n'
import LocalizableSelect from 'PMT/components/form/LocalizableSelect'
import Order from 'PMT/entities/order/Order'
import OrderModeChooser from 'PMT/components/form/OrderModeChooser'
import PaymentMethod, { getPaymentMethodOptions } from 'PMT/constants/PaymentMethod'
import Timelapse from 'PMT/entities/Timelapse'

import ApiConsumersStore from 'stores/ApiConsumersStore'
import OrderStatisticsStore from 'stores/OrderStatisticsStore'
import SessionStore from '../../../../stores/SessionStore'
import TimelapsePicker from 'components/timelapse/TimelapsePicker'

const Filters = ({ sourcesList, modes, paymentMethods, timelapse, isLoading, updateFilters, updateModes, updateTimelapse, onSubmit }) => (
  <div className="order_statistics_filters row">
    <div className="col-xs-12 col-sm-6 col-lg-3">
      <LocalizableSelect
        name="filterSource"
        placeholder={I18n.tr('order.on_going.table.header.source')}
        value={sourcesList}
        options={ApiConsumersStore.getOptions()}
        onChange={(options) => updateFilters(options, 'sourcesList')}
        multi={true}
      />
    </div>
    <div className="col-xs-12 col-sm-6 col-lg-3">
      <OrderModeChooser
        placeholder={I18n.tr('order.on_going.table.header.type')}
        onChange={(modes) => updateModes(modes)}
        multi={true}
        values={modes}
        modes={_.values(Order.OrderMode)}
      />
    </div>
    <div className="col-xs-12 col-sm-6 col-lg-3">
      <LocalizableSelect
        name="filterPayment"
        placeholder={I18n.tr('order.on_going.table.header.payment')}
        value={paymentMethods}
        options={getPaymentMethodOptions()}
        onChange={(options) => updateFilters(options, 'paymentMethods')}
        multi={true}
      />
    </div>
    <TimelapsePicker
      className="col-xs-12 col-sm-6 col-lg-3"
      timelapse={timelapse}
      onTimelapseChange={updateTimelapse}
    />
  </div>
)

Filters.propTypes = {
  sourcesList: PropTypes.array.isRequired,
  modes: PropTypes.array.isRequired,
  paymentMethods: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  updateModes: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  updateTimelapse: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default Filters
